<template>
    <div class="mt-4 mb-2 ml-3">
        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <div class="mt-5" v-if="account.notes">
            <div class="font-weight-medium mb-2 layout row">
                Notes
            </div>
            <div class="layout row mb-2" v-for="note in account.notes">
                <div class="mr-2">{{ note.date | time }} -</div>
                <div class="font-weight-medium mr-2">{{ note.byUser }}:</div>
                <div>{{ note.note }}</div>
            </div>
        </div>

        <div class="mt-5" v-if="account.transactions">
            <div class="font-weight-medium mb-3 layout row">
                Transactions:
            </div>
            <v-divider class="pb-1"></v-divider>
            <v-layout row class="my-2">
                <div class="width-100"></div>
                <div class="width-220 font-weight-medium">Date</div>
                <div class="width-200 font-weight-medium">Description</div>
                <div class="width-100 font-weight-medium">Type</div>
                <div class="width-150 font-weight-medium">Amount</div>
                <div class="width-150 font-weight-medium">Status</div>
                <div class="width-150 font-weight-medium">Receipt Number</div>
                <div class="ml-3"></div>
            </v-layout>
            <v-divider class="pb-1"></v-divider>
            <div class="" v-for="(transaction, index) in account.transactions">
                <v-layout row class="my-2">
                    <div class="width-100">
                        <v-icon
                            class="px-0"
                            dark
                            :color="
                                transaction.txnType == 'C' ? '#43a047' : 'red'
                            "
                            >mdi-currency-usd</v-icon
                        >
                    </div>
                    <div class="width-220">{{ transaction.date | date }}</div>
                    <div class="width-200">{{ transaction.description }}</div>
                    <div class="width-150">
                        {{ transaction.amount | currency }}
                    </div>
                    <div class="width-150">
                        {{
                            transaction.payment
                                ? transaction.payment.tranType
                                : ""
                        }}
                    </div>
                    <div class="width-150">
                        {{
                            transaction.payment
                                ? transaction.payment.status
                                : ""
                        }}
                    </div>
                    <div class="width-150">{{ transaction.receiptNumber }}</div>
                </v-layout>
                <v-divider
                    class="pb-1"
                    v-if="index + 1 < account.transactions.length"
                ></v-divider>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            account: "",
        };
    },
    async created() {
        await this.loadRegID();

        this.load();
    },
    computed: {},
    methods: {
        async load() {
            this.account = await this.$http.get(
                "api/ykcAccounts/GetAccountInfo?accountID=" +
                    (this.row.accountID
                        ? this.row.accountID
                        : this.row.familyID) +
                    "&regID=" +
                    this.row.regID
            );
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "date",
                    "homePhoneSearch",
                    "cellPhoneSearch",
                    "note"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
    },
};
</script>
<style></style>
